import MenuModel from '../Apis/Menu.js';
import Controller from './Controller.js';

export default class MenuController extends Controller {

    constructor() {
        super(new MenuModel());
    }
    
    async updatePriority(data, headers = {}) {
        const res = await this.model.updatePriority(data, headers);
        return this.Poup(res);
      }

    async menu(params) {

        const res = await this.model.menu(params);
        return  res;
      }
      async updateMenu(data, headers = {}) {
        const res = await this.model.updateMenu(data, headers);
        return this.Poup(res);
      }
}